import { useState } from 'react';
import { cn } from '@/lib/cn';
import { HorizontalScrollRow } from '@/ui/common';
import {
  DEFAULT_LAST_MINUTE_HOURS,
  LAST_MINUTE_HOURS_OPTIONS,
  lastMinuteHoursLabel,
  type LastMinuteHours,
} from './time-filter-config';
import { TimeFilterItem } from './TimeFilterItem';

export interface TimeFilterMenuProps {
  /** Controlled hours selection. */
  value?: LastMinuteHours;
  defaultValue?: LastMinuteHours;
  onValueChange?: (hours: LastMinuteHours) => void;
  className?: string;
}

/**
 * Figma TimeFilterMenu — horizontal hour chips for last-minute pages.
 * Options: 1 / 3 / 6 / 12 / 24 hours (no All). Default: 6 hours.
 */
export function TimeFilterMenu({
  value,
  defaultValue = DEFAULT_LAST_MINUTE_HOURS,
  onValueChange,
  className,
}: TimeFilterMenuProps) {
  const [uncontrolled, setUncontrolled] = useState<LastMinuteHours>(defaultValue);
  const selected = value ?? uncontrolled;

  const select = (hours: LastMinuteHours) => {
    if (value === undefined) {
      setUncontrolled(hours);
    }
    onValueChange?.(hours);
  };

  return (
    <HorizontalScrollRow
      aria-label="Time filter"
      className={cn('h-8 items-center gap-2 pl-0', className)}
    >
      {LAST_MINUTE_HOURS_OPTIONS.map((hours) => (
        <TimeFilterItem
          key={hours}
          label={lastMinuteHoursLabel(hours)}
          selected={hours === selected}
          onClick={() => select(hours)}
        />
      ))}
    </HorizontalScrollRow>
  );
}
